<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.qualitative_reports', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                id="title"
                                v-model="form.title"
                                name="title"
                                type="text"
                                maxlength="6"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.title" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.gradation')" for="gradation" />
                            <FormError :value="form.errors.gradation" class="mt-2" />
                            <div v-for="(gradation, index) in form.gradation" :key="index">
                                <div class="flex space-x-2 items-center">
                                    <span> {{ index + 1 }} </span>
                                    <FormInput
                                        v-model="gradation.text"
                                        type="text"
                                        minlength="2"
                                        maxlength="20"
                                        class="mt-1"
                                    />
                                    <button
                                        type="button"
                                        @click="deleteRow(index)"
                                        v-if="meta.can.modify_gradation"
                                        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                        <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                            <path
                                                fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                                <FormError :value="form.errors[`gradation.${index}.text`]" class="mt-2" />
                            </div>
                        </div>
                        <div class="mt-1" v-if="meta.can.modify_gradation">
                            <PlusButton @click="addRow()" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        PlusButton,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'qualitativeReportCategory'],
    data() {
        return {
            form: this.$inertia.form({
                title: this.qualitativeReportCategory.title,
                category_order: this.qualitativeReportCategory.category_order,
                gradation: this.qualitativeReportCategory.gradation,
            }),
        };
    },
    methods: {
        submit() {
            this.form
                .transform((data) => {
                    data.gradation = data.gradation.map((g, i) => {
                        return {
                            text: g.text,
                            value: i + 1,
                        };
                    });
                    return data;
                })
                .patch(this.meta.links.update);
        },
        addRow() {
            this.form.gradation.push({ text: '' });
        },
        deleteRow(index) {
            this.form.gradation.splice(index, 1);
            if (this.form.gradation.length === 0) {
                this.addRow();
            }
        },
    },
};
</script>
